var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":0,"ripple":!!_vm.action},on:{"click":_vm.cardClicked}},[_c('v-card-text',{staticClass:"py-2"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }